import React from 'react';
import {useDispatch} from "react-redux";
import { setReadOffCanvasIsActive } from "../../../../Features/Misc/navBarSlice"
import { setActiveRead } from "../../../../Features/Misc/activeSlice";
import ReadArticlePreviewCardRight from "./ReadArticlePreviewCardRight";
import ReadArticlePreviewCardLeft from "./ReadArticlePreviewCardLeft";



export default function ReadArticlePreviewCard({imgSrc, title, text, authorName, date, mediaType, mediaId}) {



    const dispatch = useDispatch();

    const readPayload = {
        imgSrc,
        title,
        text,
        authorName,
        date,
        mediaType,
        mediaId,
    }

    const handleClick = () => {
        dispatch(setReadOffCanvasIsActive());
        dispatch(setActiveRead(readPayload));
    };


    return (

            <div onClick={handleClick} className="readArticlePreviewCard w-full h-20 rounded-lg bg-white flex flex-row items-center pr-2 cursor-pointer hover:opacity-60 transition-opacity duration-300">
                <ReadArticlePreviewCardLeft imgSrc={imgSrc} title={title}/>
                <ReadArticlePreviewCardRight text={text} authorName={authorName} date={date} />
            </div>

    );
}
